// TODO: do we want to export this type on the value so we can access it as SCHEDULE_CALLBACK_TYPES.CallbackNow?
export const SCHEDULE_CALLBACK_TYPES = [
    "CallbackNow", // Outbound call from agent to Cx
    "CallbackLater", // Normal callback to the queue
] as const;
export type ScheduleCallbackType = (typeof SCHEDULE_CALLBACK_TYPES)[number];
